// Widget scripts
import campingWidget from './js/widgets/campingWidget.js';
import cardWidget from './js/widgets/cardWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import cssSponsors from './js/widgets/cssSponsors.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js'; 
import videoWidget from './js/widgets/videoWidget.js'; 
// Custom theme scripts
import './js/localjs.js';
import './js/SiteInfoBanner.js';
import AOS from 'aos';
import 'aos/dist/aos.css';



// Initialize homepage widgets
$(document).ready(function () {
campingWidget();
});
if (window.location.pathname === '/') {
  $(document).ready(function () {
    
    cardWidget();
    swiperWidget();
    cssSponsors();
    multiScheduleFeature(); 
    $(window).load(function () {
      videoWidget();
    })
    seoWidget(); 
  });
}

// initialize site-wide widgets
$(document).ready(function () {
  
  $(window).load(function () {
    setTimeout(() => {
      AOS.init({
        anchorPlacement: 'bottom-bottom',
        animatedClassName: 'aos-animate',
        initClassName: 'aos-init',
      });
    }, 2000)
  })
});

